import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';
import { Router } from '@angular/router';
import { BRANCH_OFFICE_URL, WHATSAPP_URL } from '@constants/business.constant';
import { URL_CONTACTO_TRAMITE_PENSION } from '@constants/url.constant';

interface PiHelpLink {
  label: string;
  url: string;
  target: '_self' | '_blank';
  internalRoute?: string;
}

/**
 * Footer de ayuda del paso 0 — Figma.
 */
@Component({
  selector: 'app-pi-help-footer',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './pi-help-footer.component.html',
  styleUrls: ['./pi-help-footer.component.scss'],
})
export class PiHelpFooterComponent {
  readonly links: PiHelpLink[] = [
    {
      label: 'Llámanos al 600 6600 900',
      url: 'tel:6006600900',
      target: '_self',
    },
    {
      label: 'Escríbenos a WhatsApp',
      url: WHATSAPP_URL,
      target: '_blank',
    },
    {
      label: 'Contacto y Reclamo',
      url: URL_CONTACTO_TRAMITE_PENSION,
      target: '_self',
      internalRoute: URL_CONTACTO_TRAMITE_PENSION,
    },
    {
      label: 'Sucursales y Centros de Servicio',
      url: BRANCH_OFFICE_URL,
      target: '_blank',
    },
  ];

  constructor(private readonly router: Router) {}

  onLinkClick(event: MouseEvent, link: PiHelpLink): void {
    if (!link.internalRoute) {
      return;
    }

    event.preventDefault();
    this.router.navigate([link.internalRoute]);
  }
}
